class ProductAccordion extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Find all product accordions in the same container
    this.container = this.closest('.product__info-container') || document;
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    
    if (!this.details || !this.summary) return;

    // Add click event listener
    this.summary.addEventListener('click', this.onToggle.bind(this));
    
    // Add keyboard support
    this.details.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  onToggle(event) {
    // Small delay to ensure the details element state is updated
    setTimeout(() => {
      if (this.details.hasAttribute('open')) {
        this.closeOtherAccordions();
        this.animateOpen();
      } else {
        this.animateClose();
      }
    }, 10);
  }

  animateOpen() {
    const content = this.details.querySelector('.accordion__content');
    if (content) {
      content.style.animation = 'slideDownSmooth 0.4s ease-out';
      content.style.opacity = '1';
    }
  }

  animateClose() {
    const content = this.details.querySelector('.accordion__content');
    if (content) {
      content.style.animation = 'slideUpSmooth 0.3s ease-in';
      setTimeout(() => {
        content.style.opacity = '0';
      }, 300);
    }
  }

  onKeyDown(event) {
    // Handle Enter and Space keys for accessibility
    if (event.target === this.summary && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      this.summary.click();
    }
    
    // Handle Escape key to close accordion
    if (event.key === 'Escape' && this.details.hasAttribute('open')) {
      this.details.removeAttribute('open');
      this.summary.focus();
    }
  }

  closeOtherAccordions() {
    // Find all other product accordions in the same container
    const otherAccordions = this.container.querySelectorAll('.product__accordion details');
    
    otherAccordions.forEach(accordion => {
      // Don't close the current accordion
      if (accordion !== this.details && accordion.hasAttribute('open')) {
        // Animate close before removing open attribute
        const content = accordion.querySelector('.accordion__content');
        if (content) {
          content.style.animation = 'slideUpSmooth 0.3s ease-in';
        }
        
        // Delay the actual closing to allow animation
        setTimeout(() => {
          accordion.removeAttribute('open');
        }, 300);
        
        // Update aria-expanded attribute for accessibility
        const summary = accordion.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }
      }
    });
    
    // Update current accordion's aria-expanded
    this.summary.setAttribute('aria-expanded', 'true');
  }

  // Public method to close this accordion
  close() {
    this.details.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
  }

  // Public method to open this accordion
  open() {
    this.closeOtherAccordions();
    this.details.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }
}

// Register the custom element
if (!customElements.get('product-accordion')) {
  customElements.define('product-accordion', ProductAccordion);
}

// Initialize existing accordions that might not be custom elements
document.addEventListener('DOMContentLoaded', function() {
  // Handle non-custom element accordions
  const productAccordions = document.querySelectorAll('.product__accordion');
  
  productAccordions.forEach(accordion => {
    // Skip if already a custom element
    if (accordion.tagName.toLowerCase() === 'product-accordion') return;
    
    const details = accordion.querySelector('details');
    const summary = accordion.querySelector('summary');
    
    if (!details || !summary) return;
    
    // Add the same functionality to regular divs
    summary.addEventListener('click', function() {
      setTimeout(() => {
        if (details.hasAttribute('open')) {
          closeOtherProductAccordions(accordion);
        }
      }, 10);
    });
    
    details.addEventListener('keydown', function(event) {
      if (event.target === summary && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        summary.click();
      }
      
      if (event.key === 'Escape' && details.hasAttribute('open')) {
        details.removeAttribute('open');
        summary.focus();
      }
    });
  });
});

function closeOtherProductAccordions(currentAccordion) {
  const container = currentAccordion.closest('.product__info-container') || document;
  const otherAccordions = container.querySelectorAll('.product__accordion details');
  const currentDetails = currentAccordion.querySelector('details');
  
  otherAccordions.forEach(accordion => {
    if (accordion !== currentDetails && accordion.hasAttribute('open')) {
      // Animate close before removing open attribute
      const content = accordion.querySelector('.accordion__content');
      if (content) {
        content.style.animation = 'slideUpSmooth 0.3s ease-in';
      }
      
      // Delay the actual closing to allow animation
      setTimeout(() => {
        accordion.removeAttribute('open');
      }, 300);
      
      const summary = accordion.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    }
  });
  
  // Update current accordion's aria-expanded and animate open
  const currentSummary = currentAccordion.querySelector('summary');
  const currentContent = currentDetails.querySelector('.accordion__content');
  
  if (currentSummary) {
    currentSummary.setAttribute('aria-expanded', 'true');
  }
  
  if (currentContent) {
    currentContent.style.animation = 'slideDownSmooth 0.4s ease-out';
    currentContent.style.opacity = '1';
  }
}
